{
  "welcome": "Bienvenido",
  "divider": "– O –",
  "continue": "Continuar",
  "checkEmailTitle": "Revisa tu correo",
  "emailLinkSent": "Revisa tu correo: te enviamos un enlace para iniciar sesión.",
  "spamHint": "Si no recibes el correo, revisa tu carpeta de spam o <retryLink>inténtalo de nuevo</retryLink> en 5 minutos.",
  "terms": "Al continuar, aceptas los <termsLink>Términos del servicio</termsLink> y reconoces la <privacyLink>Política de privacidad</privacyLink>.",
  "loginLinkOffer": "Mejor envíame un enlace de inicio de sesión",
  "didYouMean": "¿Quisiste decir <suggestionButton>{{suggestion}}</suggestionButton>?",
  "verifyPrompt": "Para activar tu cuenta, debes verificar tu dirección de correo. Puedes solicitar un nuevo correo de confirmación.",
  "verificationRequiredTitle": "Confirma tu correo para continuar",
  "verificationRequiredBody": "Enviamos un enlace de confirmación a {{email}}. Ábrelo para seguir usando Profiling.app.",
  "verificationWrongAddress": "¿Dirección incorrecta? Cámbiala",
  "changeEmail": "Cambiar correo",
  "changePassword": "Cambiar contraseña",
  "myAccount": "Mi cuenta",
  "nameWorkspace": "Nombra tu espacio de trabajo",
  "emailVerified": "Se verificó tu dirección de correo.",
  "emailVerifyError": "No se pudo verificar el correo. Inténtalo de nuevo.",
  "signedIn": "Has iniciado sesión.",
  "loginLinkError": "Este enlace de inicio de sesión no es válido o ha expirado.",
  "accountCreated": "Se creó una cuenta nueva para {{email}}. Te enviamos un enlace de verificación por correo.",
  "socialError": "Error de autenticación.",
  "verificationEmailSent": "Correo de verificación enviado.",
  "emailPlaceholder": "Correo electrónico",
  "passwordPlaceholder": "Contraseña",
  "passwordHelper": "Tu contraseña, o elige una para registrarte. Déjala en blanco y te enviaremos un enlace de inicio de sesión por correo."
}
